const CARD_NET_APY_CONFIG = {
  color: {
    small: 'bg-card',
    large: 'bg-muted'
  },
  dimensions: {
    small: {
      height: {
        expanded: '100%',
        collapsed: '100%'
      },
      width: {
        expanded: '100%',
        collapsed: '100%'
      }
    },
    large: {
      height: {
        expanded: 'auto',
        collapsed: '91px'
      },
      width: {
        expanded: '342px',
        collapsed: '342px'
      }
    }
  }
} as const

export const getCardNetApyConfig = (isSmall?: boolean, isExpanded?: boolean) => {
  const size = isSmall ? 'small' : 'large'
  const height = isExpanded ? 'expanded' : 'collapsed'

  return {
    height: CARD_NET_APY_CONFIG.dimensions[size].height[height],
    width: CARD_NET_APY_CONFIG.dimensions[size].width[height],
    background: CARD_NET_APY_CONFIG.color[size]
  }
}
